import React from "react";
import dayjs from "dayjs";

function MessageA3(props) {
  const isHtml = (string) => {
    console.log(string, "MESSAGE DATA IN A3 HERE ");
    return !!(string.includes("<") || string.includes("</"));
  }

  const messageTimeClassName = () => {
    return "s360-message-time-received";
  };

  const messageBoxClassName = () => {
    return localStorage.getItem("openInFullScreen")
      ? "s360-message-box-received-fs"
      : "s360-message-box-received";
  };

  const messageContainerClassName = () => {
    return props.config.autoFullScreen
      ? "s360-message-cotainer-received-fs"
      : "s360-message-cotainer-received";
  };

  const messageBoxStyle = () => {
    let config = props.config;
    return {
      fontWeight: 400,
      ...config?.customDesign?.messageA3Box
    };
  };


  const messageTimeStyle = () => {
    let config = props.config;
    return config?.customDesign?.messageA3Time;
  };

  const text = props?.entry?.text || "";
  text.replace(/\n/g, "<br/>");

  return (
    <div className={messageContainerClassName()}>
      {isHtml(text) ? (
        <div
          className={messageBoxClassName()}
          style={messageBoxStyle()}
          dangerouslySetInnerHTML={{ __html: text }}
        ></div>
      ) : (
        <span
          className={messageBoxClassName()}
          style={messageBoxStyle()}
        >

          {text}
        </span>
      )}
      {props.sentTimestamp && (
        <div
          className={messageTimeClassName()}
          style={messageTimeStyle()}
        >
          {dayjs
            .unix(Math.trunc(props.sentTimestamp / 1000))
            .format("DD MMM h:mm a")}
        </div>
      )}
    </div>
  );
}

export default MessageA3;
